import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import React, { useEffect, useState } from 'react';
import Svg, { Path, Text as QRText, G } from 'react-native-svg';
import { cssInterop } from "react-native-css-interop";
import QRCode from 'qrcode'

const PathStyled = (props) => {
//   console.log('CSS', props)
  return <Path {...props} />
}

cssInterop(PathStyled, {
  className: {
    target: 'style',
    nativeStyleToProp: {
      color: 'stroke',
    },
  },
})

export default function QRCodeView(props) {
    const { data, title, text } = props
    const [viewBox, setViewBox] = useState('0 0 20 20');
    const [path, setPath] = useState('');

    useEffect(() => {
        // version / Type: Number / QR Code version. If not specified the more suitable value will be calculated.
        // errorCorrectionLevel / Type: String / Default: M
        // Error correction level. / Possible values are low, medium, quartile, high or L, M, Q, H.
        // maskPattern / Type: Number / Mask pattern used to mask the symbol. / Possible values are 0, 1, 2, 3, 4, 5, 6, 7. / If not specified the more suitable value will be calculated.
        // toSJISFunc / Type: Function / Helper function used internally to convert a kanji to its Shift JIS value. / Provide this function if you need support for Kanji mode.
        // margin Type: Number / Default: 4 / Define how much wide the quiet zone should be.
        // scale Type: Number / Default: 4 / Scale factor. A value of 1 means 1px per modules (black dots).
        // small Type: Boolean / Default: false / Relevant only for terminal renderer. Outputs smaller QR code.
        // width Type: Number / Forces a specific width for the output image. / If width is too small to contain the qr symbol, this option will be ignored / . Takes precedence over scale.
        // color.dark / Type: String / Default: #000000ff / Color of dark module. Value must be in hex format (RGBA). / Note: dark color should always be darker than color.light.
        // color.light / Type: String / Default: #ffffffff
        if (data) {
            QRCode.toString(data, { type: 'svg', errorCorrectionLevel: 'Q', margin: 0 }, function (err, svg) {
                const info = svg.match(/"[^"]+"/g).map(i => i.replace(/"/g, ''))
                // console.log(info)
                setViewBox(info[1])
                setPath(info[6])
            })
        }
    }, [data])

    return (
        <VStack {...props} className={` shadow-hard-3 justify-center items-center w-[95%] h-[400px] py-4 bg-secondary-50 border border-secondary-300 rounded-xl ${props.className ? props.className : ''}`}>
            <Svg height="80%" width="80%" viewBox={viewBox} shapeRendering="crispEdges">
                <PathStyled className="text-primary-900" d={path} />
                <G transform='rotate(45)'>
                    <QRText fill='#808080C0' stroke='none' fontSize={10} fontWeight={700} textAnchor="middle" x='25' y='3'>{props.overlay ? props.overlay : ''}</QRText>
                </G>
            </Svg>
            <Text className="font-[700] mt-2 text-2xl leading-2xl text-secondary-900 line-clamp-1">{title}</Text>
            {text && <Text className="text-2xl leading-2xl text-secondary-900 line-clamp-1">{text}</Text>}
        </VStack>
    );
}